<template lang="html">
    <el-dialog class="dialog"
        :visible.sync="dialogVisiable"
        :show-close="true"
        :center="true"
        :before-close="closeDialog"
        :append-to-body="appendToDialog"
        :close-on-click-modal="false"
        custom-class="approval-dialog"
        width="450px"
    >   
        <div class="approval-info">
            <i class="iconfont" :class="type === 'confirm'?'icon-shenpitongguo':'icon-shenpijujue'"></i>
            <span>审批{{type == 'confirm'?'通过':'拒绝'}}　　</span>
        </div>
        <div class="apprvoal-reason">
            <el-input maxlength="200" type="textarea" v-model="reason" :placeholder="'请输入审批'+(type == 'confirm'?'通过':'拒绝')+'理由（选填）'"></el-input>
        </div>
        <span slot="footer">
            <el-button type="primary" @click="handleConfirmOK">{{$t("btn.confirm")}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
  export default {
    props: {
        'dialogVisiable': {
            type: Boolean,
            required: true
        },
        'confirm': {
            type: Function,
            required: true
        },
        'reject': {
            type: Function,
            required: true
        },      
        'type': {
            type: String,
            required: true
        },
        'cancel': {
            type: Function
        },  
        'appendToDialog': {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            reason: ''
        }
    },
    methods: {
        handleConfirmOK(){
            this.$emit('update:dialogVisiable', false)
            if(this.type == 'confirm') {
                if(this.confirm){
                    this.confirm(this.reason);
                }
            }
            else {
                if(this.reject){
                    this.reject(this.reason);
                }
            }
        },
        closeDialog(done) {
            // done(); //使用done会有js报错
            this.$emit('update:dialogVisiable', false)
            if(this.cancel){
                this.cancel();
            }
        }
    }
  };
</script>

<style lang="less" scoped>
.approval-dialog {

    .iconfont{
        font-size: 24px;
    }
    .icon-shenpijujue {
        color: #e40030;
    }
    .icon-shenpitongguo {
        color: #008748;   
    }
    .approval-info {
        text-align: center;
        font-size: 16px;
        font-weight: bold;

        span {
            vertical-align: top;
            height: 28px;
            line-height: 28px;
        }
    }

    .apprvoal-reason {
        margin: 16px auto 0 auto;
        width: 360px;

        textarea {
            height: 180px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// ApprovalDialog.vue?9f830cb2